import axios from 'axios';
import { OK } from '../Common';

const endpoint = process.env.REACT_APP_API_URL;
const url = `${endpoint}/mail/delivery/stop`;

export interface MailDeliveryStopApiResponse {
  resultStatus: boolean;
}

export interface MailDeliveryStopApiRequest {
  customerId: number;
  token: string;
}

/**
 * メール配信停止API
 * @param request リクエスト
 */
export async function getMailDeliveryStopApi(request: MailDeliveryStopApiRequest): Promise<MailDeliveryStopApiResponse> {
  const { customerId, token } = request;
  try {
    const response = await axios.get(`${url}/${customerId}/${token}`);
    switch (response.status) {
      case OK.status:
        return {
          resultStatus: response.data.resultStatus,
        };
      default:
        throw new Error();
    }
  } catch (error) {
    return {
      resultStatus: false,
    };
  }
}
